import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TextButtonComponent } from 'src/app/shared/components';

export interface ConfirmationDialogData {
  title: string;
  description: string;
  acceptButton: string;
  rejectButton: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TextButtonComponent],
})
export class ConfirmationDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);
  data = inject<ConfirmationDialogData>(MAT_DIALOG_DATA);

  title: string;
  description: string;
  acceptButton: string;
  rejectButton: string;

  constructor() {
    const data = this.data;

    this.title = data.title;
    this.description = data.description;
    this.acceptButton = data.acceptButton;
    this.rejectButton = data.rejectButton;
  }

  reject() {
    this.dialogRef.close();
  }

  accept() {
    this.dialogRef.close(true);
  }
}
